module.exports = __webpack_public_path__ + "static/media/group_copy_3.1d56d131.jpg";